import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'li' | 'span';
}
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.35
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-127" data-mp="3gfnub17ml1au">
      {children}
    </MotionTag>;
}